import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { GSIcon } from 'src/components/shared/GSIcon'
import { colors } from 'src/theme'

export interface ContractorStepDetailsDeclineReasonBlockProps {
  declineReason?: string
}

const ContractorStepDetailsDeclineReasonBlockComponent = ({
  declineReason,
}: ContractorStepDetailsDeclineReasonBlockProps) => {
  return (
    <div css={tw`rounded-xl px-4 pb-4 pt-0`}>
      <div
        css={[
          tw`rounded-xl p-4 flex flex-row items-center`,
          { backgroundColor: colors.SHADES_GREY_100 },
        ]}
      >
        <GSIcon iconName="gs_circle_info" width={40} />
        <Typography variant="body2" css={tw`ml-3`}>
          This step was declined for the following reason:{' '}
          <Typography component="span" variant="h6">
            {declineReason}
          </Typography>
        </Typography>
      </div>
    </div>
  )
}

export const ContractorStepDetailsDeclineReasonBlock = memo(
  ContractorStepDetailsDeclineReasonBlockComponent,
)
